/**
 * SEO helpers for per-route canonical + og:url.
 * Use in a leaf route's `head()` to keep canonical and og:url self-referential.
 *
 * Example:
 *   head: () => ({
 *     meta: [
 *       { title: "..." },
 *       ...canonicalMeta("/about"),
 *     ],
 *     links: [canonicalLink("/about")],
 *   })
 */
export const SITE_URL = "https://drsaranahas.com";

export function absoluteUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
}

export function canonicalLink(path: string) {
  return { rel: "canonical", href: absoluteUrl(path) } as const;
}

export function canonicalMeta(path: string) {
  return [{ property: "og:url", content: absoluteUrl(path) }] as const;
}

/** Brand share card used by pages that have no image of their own. */
export const DEFAULT_OG_IMAGE = "/og/default.png";

/** og:image + twitter:image (1200x630) for a page share card. */
export function ogImageMeta(path: string = DEFAULT_OG_IMAGE) {
  const url = path.startsWith("http") ? path : absoluteUrl(path);
  return [
    { property: "og:image", content: url },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { name: "twitter:image", content: url },
    { name: "twitter:card", content: "summary_large_image" },
  ] as const;
}